import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTableTextCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";

const catalogEntry = fgColumnEntries["street-address"];

function getTwoLineAddress(row: FulfillmentGroupData) {
  const address = row.verifiedDestinationAddress || row.destinationAddress;
  const line1 = [address?.address1, address?.address2]
    .filter(Boolean)
    .join(" ");
  const cityState = [address?.city, address?.province]
    .filter(Boolean)
    .join(", ");
  const line2 = [cityState, address?.zip].filter(Boolean).join(" ");

  return [line1, line2];
}

export const StreetAddressColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => {
    const [line1, line2] = getTwoLineAddress(row);

    // @ts-expect-error TODO: noUncheckedIndexedAccess FIXME
    return <RedoTableTextCell subtext={line2} text={line1} />;
  },
  width: catalogEntry.defaultWidth,
};
